/**
 * BBCode renderer — phpBB-authentic markup, XSS-safe.
 * HTML is escaped FIRST; only our own tags are introduced afterwards.
 */

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function safeUrl(u: string): string | null {
  const t = u.trim();
  if (/^https?:\/\/[^\s"'<>]+$/i.test(t)) return t;
  return null;
}

export function renderBBCode(input: string): string {
  let s = escapeHtml(input);

  // [code]...[/code] first, protect contents from further processing
  const codes: string[] = [];
  s = s.replace(/\[code\]([\s\S]*?)\[\/code\]/gi, (_, c) => {
    codes.push(c);
    return `${codes.length - 1}`;
  });

  s = s
    .replace(/\[b\]([\s\S]*?)\[\/b\]/gi, '<strong>$1</strong>')
    .replace(/\[i\]([\s\S]*?)\[\/i\]/gi, '<em>$1</em>')
    .replace(/\[u\]([\s\S]*?)\[\/u\]/gi, '<u>$1</u>')
    .replace(/\[s\]([\s\S]*?)\[\/s\]/gi, '<del>$1</del>')
    .replace(/\[quote\]([\s\S]*?)\[\/quote\]/gi, '<blockquote class="bb-quote">$1</blockquote>')
    .replace(/\[quote=&quot;([^&]*)&quot;\]([\s\S]*?)\[\/quote\]/gi, '<blockquote class="bb-quote"><cite>$1 wrote:</cite>$2</blockquote>')
    .replace(/\[url=([^\]]*)\]([\s\S]*?)\[\/url\]/gi, (_m, u, label) => {
      const url = safeUrl(u);
      return url ? `<a href="${url}" target="_blank" rel="noopener noreferrer nofollow">${label}</a>` : label;
    })
    .replace(/\[url\]([\s\S]*?)\[\/url\]/gi, (_m, u) => {
      const url = safeUrl(u);
      return url ? `<a href="${url}" target="_blank" rel="noopener noreferrer nofollow">${url}</a>` : u;
    })
    .replace(/\[img\]([\s\S]*?)\[\/img\]/gi, (_m, u) => {
      const url = safeUrl(u);
      return url ? `<img class="bb-img" src="${url}" alt="" loading="lazy">` : '[img]';
    });

  // autolink bare URLs
  s = s.replace(/(^|[\s(])((?:https?:\/\/)[^\s<)"']+)/g, (m, pre, u) => {
    const url = safeUrl(u);
    return url ? `${pre}<a href="${url}" target="_blank" rel="noopener noreferrer nofollow">${u}</a>` : m;
  });

  s = s.replace(/\[(\d+)\]/g, (_, i) => `<pre class="bb-code"><code>${codes[Number(i)]}</code></pre>`);

  return s.replace(/\n/g, '<br>');
}

/** Strip BBCode to plain text (for previews/last-post snippets). */
export function bbcodeToText(input: string): string {
  return input
    .replace(/\[quote[^\]]*\][\s\S]*?\[\/quote\]/gi, '')
    .replace(/\[(?:\/)?[a-z]+(?:=[^\]]*)?\]/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
}
